var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-100 d-flex flex-column align-items-center justify-content-center"},[_c('button',{staticClass:"btn btn-light btn-own mb-3 align-self-center",attrs:{"type":"button"},on:{"click":function($event){return _vm.buyCodeBtn()}}},[_vm._v(" Купить код активации ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }